enum ScreenStandardGroup{
    ACTION = "ActionScreenStandardGroup",
    AUDITS = "AuditsScreenStandardGroup",
    INDICATORS = "IndicatorsScreenStandardGroup",
    MEETINGS = "MeetingScreenStandardGroup",
    OCCURRENCES = "OccurrencesScreenStandardGroup",
    OKR = "OKRScreenStandardGroup",
    RISKS = "RisksScreenStandardGroup"
}

export default ScreenStandardGroup;
